export const mapping = {
  follow_up: '跟进',
  approach: '洽谈',
  cooperation: '合作',
  open_account: '开户',
  cost_test: '消耗测试',
  cost_stable: '消耗稳定',
  cost_continued: '消耗持续',
};

export const legend = {
  bottom: '0',
};

export const series = {
  type: 'funnel',
  left: 0,
  top: 32,
  bottom: 50,
  width: '80%',
  min: 0,
  minSize: '0%',
  maxSize: '100%',
  sort: 'descending',
  gap: 0,
  label: {
    color: '#565656',
    fontFamily: 'DINPro-Medium, PingFang SC',
    formatter: '{b} {c}',
  },
  labelLine: {
    length: 35,
    lineStyle: {
      width: 1,
      type: 'solid',
      color: '#dedede',
    },
  },
};
